import React, {useRef, useState, useEffect, useCallback} from 'react';
import {getTouch} from "utils/getTouch.js";
import {MUTES, DELETE} from "components/pads/modes.js";
const MIN_TIME = 250;
const MIN = -65;

export const useVolumeMove = (
    ref,
    track,
    setParameterSliderDown,
    mode,
    volume,
    refs,
    pad
) => {
    let lastClick = useRef(0);
    let [mouseDown, setMouseDown] = useState(false);
    let mouseRef = useRef(false);
    let [pt, setPt] = useState(undefined);
    let [moved, setMoved] = useState(false);

    useEffect(() => {
        mouseRef.current = mouseDown;
    }, [mouseDown]);

    const onMouseLeave = useCallback(() => {
        //setMouseDown(false);
        //setMoved(undefined);
        //setParameterSliderDown(undefined);
    }, [setMouseDown, setMoved]);

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => window.removeEventListener("mouseup", onMouseUp);
        
    }, [setMoved,  track, mode, setMouseDown]);

    const onMouseMove = useCallback((e) => {
        if (e.metaKey || mode === DELETE || mode === MUTES || !mouseRef.current || !track) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        
        let clientY = e.clientY;
        if (e.touches) {
            if (e.touches.length > 0) {
                e.preventDefault();
            }
            clientY = getTouch(e, refs).clientY;
        }
        let el = ref.current.getBoundingClientRect();
        let height = ref.current.offsetHeight;
        let y = height - (clientY - el.top);
        let vol = getVolume(y, MIN, 6, height);
        if (pad) {
            pad.sendSliderLevels();
        }
        track.setVolume(vol, false, false);
        setMoved({x: e.clientX, y: e.clientY});
    }, [setMoved,  track, mode]);

    const onMouseDown = useCallback((e) => {
        if (e.metaKey || e.ctrlKey || mode === DELETE || mode === MUTES) {
            return;
        }
        if (!track) { return; }
        if (pad) {
            pad.mouseDown(pad.slots.indexOf(track), true);
        }
        setParameterSliderDown(track.volumeParameter);
        setMouseDown(true);
        setPt({x: e.clientX, y: e.clientY});
        lastClick.current = new Date().getTime();
    }, [setMouseDown, setPt, track, mode]);

    const onMouseUp = useCallback((e) => {
        if (!mouseRef.current) {
            return;
        }
        if (e.metaKey) {
            return;
        }
        pad.mouseDown(pad.slots.indexOf(track), false);
        setMoved(undefined);
        setMouseDown(false);
        setParameterSliderDown(undefined);
    }, [setMoved, setMouseDown, moved, pt]);

    let innerStyle = {
        height: track && getHeight(volume !== undefined ? volume : track.volumeParameter.get(), MIN, 6, ref.current && ref.current.offsetHeight)
    };
    
    return {
        innerStyle,
        onMouseLeave,
        onMouseDown,
        onMouseUp,
        onMouseMove,
        mouseDown
    };
};

const dist = (pt1, pt2) => {
    return Math.abs(pt1.y - pt2.y);
};

function getVolume(x, min=-40, max=6, height) {
    x = Math.min(Math.max(0, x), height);
    let ratio = x / height;
    let fullRatio = Math.pow(ratio, 0.5);
    return min + (max - min) * fullRatio;
}

function getHeight(volume, min=-40, max=6, height) {
    let ratio = getVolumeRatio(volume, min, max, height);
    return height * Math.pow(ratio, 2);
}

function getVolumeRatio(volume, min=-40, max=6) {
    return (volume - min) / (max - min);
}

const sq = (x) => x*x;
const sqrt = (x) => Math.sqrt(x);

